// features/hives/ui/hivesFilters/HivesFilterDrawer.tsx
import {FC} from 'react';
import {Drawer} from 'shared/ui/drawer';
import Button from '@atomaro/ui-kit/components/Button/Button/Button';
import {Control} from 'react-hook-form';
import {HivesFiltersFormValues, ShortLabels} from 'features/hives/lib/useHivesFilters';
import {HivesFiltersRangeItem} from './HivesFiltersRangeItem';
import {
  HivesFiltersBody,
  HivesFiltersDrawerWrapper,
  HivesFiltersFooter,
} from 'features/hives/ui/hivesTable/styles';
import {NewEntrieHead, NewEntrieTitle} from 'features/hives/ui/hivesNew/styles';
import {CloseIcon} from 'shared/ui/icons';
import {toRem} from 'shared/helpers';
import {HivesDictionariesFilter} from './HivesDictionariesFilter';

type Props = {
  isOpen: boolean;
  control: Control<HivesFiltersFormValues, any, HivesFiltersFormValues>;
  shortLabels: ShortLabels;
  dictionaryItems: {id: string; name: string; isSelected: boolean}[];
  onRangeChange: (name: keyof HivesFiltersFormValues, value: string) => void;
  onResetField: (key: string) => void;
  onDictionaryItemClick: (id: string) => void;
  onDictionaryReset: () => void;
  onClose: () => void;
  onSubmit: () => void;
  isMobile?: boolean;
  showResetAll: boolean;
  onAllReset: () => void;
};

export const HivesFilterDrawer: FC<Props> = ({
  isOpen,
  control,
  shortLabels,
  dictionaryItems,
  onRangeChange,
  onResetField,
  onDictionaryItemClick,
  onDictionaryReset,
  onClose,
  onSubmit,
  isMobile,
  showResetAll,
  onAllReset,
}) => {
  return (
    <Drawer isOpen={isOpen} onClose={onClose} position="right">
      <HivesFiltersDrawerWrapper>
        <NewEntrieHead>
          <Button
            iconPrefix={<CloseIcon />}
            variant="secondary"
            colorScheme="neutral"
            style={{alignSelf: 'flex-end', width: isMobile ? toRem(24) : toRem(36)}}
            size={isMobile ? 's' : 'm'}
            onClick={onClose}
          />
          <NewEntrieTitle>
            <span>Фильтры</span>
            {showResetAll && <button onClick={onAllReset}>Сбросить все</button>}
          </NewEntrieTitle>
        </NewEntrieHead>
        <HivesFiltersBody>
          <HivesFiltersRangeItem
            name="Рамки"
            control={control}
            fieldNames={{from: 'framesFrom', to: 'framesTo'}}
            onChange={onRangeChange}
            showReset={!!shortLabels.frames}
            onResetClick={() => onResetField('frames')}
          />
          <HivesFiltersRangeItem
            name="Сила"
            control={control}
            fieldNames={{from: 'powerFrom', to: 'powerTo'}}
            onChange={onRangeChange}
            showReset={!!shortLabels.power}
            onResetClick={() => onResetField('power')}
          />
          <HivesFiltersRangeItem
            name="Расплод"
            control={control}
            fieldNames={{from: 'broodFrom', to: 'broodTo'}}
            onChange={onRangeChange}
            showReset={!!shortLabels.brood}
            onResetClick={() => onResetField('brood')}
          />
          <HivesDictionariesFilter
            items={dictionaryItems}
            onItemClick={onDictionaryItemClick}
            onReset={onDictionaryReset}
          />
        </HivesFiltersBody>
        <HivesFiltersFooter>
          <Button label="Применить" style={{width: '100%'}} onClick={() => onSubmit()} />
        </HivesFiltersFooter>
      </HivesFiltersDrawerWrapper>
    </Drawer>
  );
};
